// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__y+30J","effect":"style_effect__sa13+","companyLogo":"style_companyLogo__jFFBX"};